import { render } from "./Purchasers.vue?vue&type=template&id=01a52884&scoped=true"
import script from "./Purchasers.vue?vue&type=script&lang=js"
export * from "./Purchasers.vue?vue&type=script&lang=js"

import "./Purchasers.vue?vue&type=style&index=0&id=01a52884&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a52884"],['__file',"src/views/Buyback/Purchasers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01a52884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01a52884', __exports__)) {
    api.reload('01a52884', __exports__)
  }
  
  module.hot.accept("./Purchasers.vue?vue&type=template&id=01a52884&scoped=true", () => {
    api.rerender('01a52884', render)
  })

}


export default __exports__